import type { RouteObject } from 'react-router';
import { NameChangePage } from './NameChangePage';

/** Detail routes (paths without a leading slash). */
export const SERVICES_ROUTES: RouteObject[] = [{ path: 'name-changes/:id', element: <NameChangePage /> }];
